import React from 'react';
import {connect} from 'react-redux';
import {resetLayers, setCentreMessage, toggleDisclaimer} from '../actions';
import settings from '../config/app_settings';
import './Nav.css';

class Nav extends React.Component {
  onFeedback = () => {
    const { dispatch } = this.props;
    const { feedback_email } = settings.links;

    dispatch(setCentreMessage((
      <div>Please send feedback to: <a href={'mailto:' + feedback_email}>{feedback_email}</a></div>), 'Feedback'));
  };

  onPrint = () => {
    window.print();
  };

  onReset = () => {
    const { dispatch } = this.props;
    dispatch(resetLayers());
  };

  onDisclaimer = () => {
    const { dispatch } = this.props;
    dispatch(toggleDisclaimer());
  };

  render() {
    const { help_page, support_page } = settings.links;
    const { pop_out } = this.props;
    return (
      <div className="nav">
        <div className="nav__logo" onClick={this.onDisclaimer}/>
        <div className="nav__links">
          <div className="button-group">
            <div className="buttons">
              {!pop_out &&
               <a className="c-button" href={help_page} target="_blank" rel="noopener noreferrer">
                 <i className="fa fa-info-circle"/>
                 <label>Help</label>
               </a>
              }
              {!pop_out &&
               <a className="c-button" href={support_page} target="_blank" rel="noopener noreferrer">
                 <i className="fa fa-question-circle"/>
                 <label>Support</label>
               </a>
              }
              <div className="c-button print" onClick={this.onPrint}>
                <i className="fa fa-print"/>
                <label>Print</label>
              </div>
              {!pop_out &&
               <div className="c-button" onClick={this.onDisclaimer}>
                 <i className="fas fa-exclamation-triangle"/>
                 <label>Disclaimer</label>
               </div>
              }
            </div>
          </div>
        </div>
        <div className="nav__spacer"/>
        {!pop_out &&
         <React.Fragment>
           <div className="buttons reset-button">
             <div className="c-button" title="Reset boundary and indicator layers" onClick={this.onReset}>
               <i className="far fa-undo"/>
               <label>Reset</label>
             </div>
           </div>
           <div className="nav__contents">
             {this.props.children}
           </div>
         </React.Fragment>}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    graphs_open: state.view.graphs_open,
    graph_view_expanded: state.view.graph_view_expanded,
    pop_out: state.view.pop_out
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Nav);



// WEBPACK FOOTER //
// ./src/containers/Nav.js